import React, { useState, useMemo, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const RegisterContext = createContext();

function RegisterProvider({ children }) {
  const [signUpUsername, setSignUpUsername] = useState('');
  const [accountType, setAccountType] = useState('');

  return (
    <RegisterContext.Provider
      value={useMemo(
        () => ({
          signUpUsername,
          setSignUpUsername,
          accountType,
          setAccountType,
        }),
        [signUpUsername, accountType],
      )}
    >
      {children}
    </RegisterContext.Provider>
  );
}

function useRegisterContext() {
  const context = useContext(RegisterContext);
  if (!context) {
    throw new Error('Context is not initialised');
  }
  return context;
}

RegisterProvider.propTypes = {
  children: PropTypes.element,
};

export { RegisterProvider, useRegisterContext };
